import React from 'react'
import ReactDOM from 'react-dom'
import WidgetApp from 'WidgetApp'
import RateTableApp from './App'

ReactDOM.render(
  <WidgetApp>
    <RateTableApp />
  </WidgetApp>,
  document.getElementById('root'),
)
